/**
 * This file should contain javascript that is specific to the public website.
 */

import objectFitImages from 'object-fit-images';
import fitvids from 'fitvids';

$(document).ready(() => {

  objectFitImages($('img.cover, img.contain'));

  fitvids('.content');

});
